<template>

  <div class="progress">
    <span v-if="label">{{ L.localize(label) }}</span>

    <progress
      class="progress__bar"
      :value="currentProgress"
      :max="maxProgress"
    />

    <span class="progress__indication" v-if="showValues">{{ shownValue }}</span>
  </div>
</template>

<script>
import _ from "lodash";
import Format from "services/Format";
import L from "services/Localization";

// Usage: <ProgressBar :percent="25" />
export default {
  name: "progress-bar",
  props: {
    label: {
      type: String,
      required: false,
      default: undefined
    },
    percent: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    showValues: {
      type: Boolean,
      required: false,
      default: true
    },
    doNotExceedMax: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      L: L,
      currentProgress: 0,
      maxProgress: 0
    };
  },
  created() {
    this.currentProgress = this.percent;
    this.maxProgress = this.max;
    if (this.doNotExceedMax && this.currentProgress > this.maxProgress) {
      this.maxProgress = this.currentProgress;
    }
  },
  computed: {
    percentage() {
      let percentage = this.currentProgress / this.maxProgress * 100;
      return _.isFinite(percentage) ? percentage : 100;
    },
    position() {
      return `left: ${this.percentage}%;`;
    },
    width() {
      return `width: ${this.percentage}%;`;
    },
    shownValue() {
      return `${this.currentProgress} / ${this.maxProgress} (${Format.roundAndPercent(
        this.percentage
      )})`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// ProgressBar.vue?1e9ca414